import { j as o } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as i } from "../../../node_modules/clsx/dist/clsx.m.js";
import { Typography as p } from "../Typography/Typography.js";
import t from "./TimePicker.module.scss.js";
import m from "../ScrollbarContainer/ScrollBarContainer.js";
const k = ({
  header: e,
  items: s,
  selected: x,
  isDisabledItem: n,
  digital: c,
  withPortal: a = !0,
  onItemChange: l
}) => /* @__PURE__ */ o.jsxs("div", { children: [
  e && /* @__PURE__ */ o.jsx("div", { className: t.timePickerHeader, children: /* @__PURE__ */ o.jsx(
    p,
    {
      variant: "interface/strong/s",
      text: e,
      textColor: "color/fg/bold"
    }
  ) }),
  /* @__PURE__ */ o.jsx(
    "div",
    {
      className: i(t.timePickerItems, {
        [t.digitalTimePicker]: c,
        [t.timePickerColumnMinutes]: e === "Mins"
      }),
      children: /* @__PURE__ */ o.jsx(m, { height: a ? "270px" : "400px", children: /* @__PURE__ */ o.jsx(
        "div",
        {
          className: i("flex flex-col items-center p-100", {
            "p-150": !c
          }),
          children: s.map((r) => /* @__PURE__ */ o.jsx(
            "div",
            {
              className: i(t.timePickerItem, {
                [t.selected]: x === String(r),
                [t.disabled]: n == null ? void 0 : n(String(r)),
                [c ? "w-[100px]" : "w-[38px]"]: !0
              }),
              ...!(n != null && n(String(r))) && {
                onClick: () => l(r),
                onKeyDown: (f) => f.code === "Enter" && l(r),
                tabIndex: 0,
                role: "button"
              },
              "data-testid": "time-input",
              children: /* @__PURE__ */ o.jsx(
                p,
                {
                  variant: "interface/medium/sm",
                  text: String(r),
                  textColor: x === String(r) ? "color/fg/inverse" : "color/fg/default"
                }
              )
            },
            String(r)
          ))
        }
      ) })
    }
  )
] });
export {
  k as default
};
//# sourceMappingURL=TimePickerColumns.js.map
